import React from 'react';

import Box from '@mui/material/Box';

import { useTranslation } from 'next-i18next';

import BackLink from 'src/components/ui/BackLink';

import type { Medium, NewsPost, NewsPostQuery } from 'src/types/__generated__/graphql';

import InteractionsCTAs from 'src/components/news/InteractionsCTAs';
import NewsPostMenu from 'src/components/news/NewsPostMenu';
import { colours } from 'src/constants/colours';
import useAppRouter from 'src/hooks/useAppRouter';
import useUser from 'src/hooks/useUser';

interface Props {
    newsPost: NonNullable<NewsPostQuery['newsPost']>;
}

const NewsPostHeader: React.FC<Props> = ({ newsPost }) => {
    const { t } = useTranslation(['ad', 'common']);
    const router = useAppRouter();
    const currentUser = useUser();
    return (
        <Box py={2} display="flex" alignItems="center" justifyContent="space-between">
            <BackLink onClick={() => router.back()}>{t('common:back')}</BackLink>
            <InteractionsCTAs
                newsPost={{ ...newsPost, media: newsPost.media as Medium[] }}
                renderAfter={
                    currentUser && (
                        <Box ml={1}>
                            <NewsPostMenu
                                newsPost={newsPost as NewsPost}
                                buttonProps={{
                                    size: 'large',
                                    iconProps: { color: colours.primary.main },
                                }}
                            />
                        </Box>
                    )
                }
            />
        </Box>
    );
};

export default NewsPostHeader;
